// client/src/pages/Admin/ExamEditor/ExamQuestionEditor.jsx
import { useState } from "react";

export default function ExamQuestionEditor({ value, index, onChange, onRemove }) {
  const [expanded, setExpanded] = useState(false);

  const updateQuestion = (field, newValue) => {
    onChange({
      ...value,
      [field]: newValue,
    });
  };

  const updateOption = (optionIndex, newText) => {
    const updatedOptions = [...value.options];
    updatedOptions[optionIndex] = {
      ...updatedOptions[optionIndex],
      text: newText,
    };
    onChange({
      ...value,
      options: updatedOptions,
    });
  };

  const setCorrectAnswer = (label) => {
    onChange({
      ...value,
      correctAnswer: label,
    });
  };

  // ולידציה של השאלה
  const isValid = () => {
    return (
      value.question.trim() !== "" &&
      value.options.every(opt => opt.text.trim() !== "") &&
      value.correctAnswer !== ""
    );
  };

  const getValidationErrors = () => {
    const errors = [];
    if (!value.question.trim()) errors.push("חסר טקסט שאלה");
    if (value.options.some(opt => !opt.text.trim())) errors.push("יש תשובות ריקות");
    if (!value.correctAnswer) errors.push("לא נבחרה תשובה נכונה");
    return errors;
  };

  return (
    <div className="card" style={{
      border: isValid() ? "1px solid var(--accent)" : "1px solid #e74c3c",
      position: "relative"
    }}>
      {/* כותרת השאלה */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "12px"
      }}>
        <h4 style={{ margin: 0, color: "#ffffff" }}>
          שאלה {index + 1}
          {!isValid() && (
            <span style={{ color: "#e74c3c", fontSize: "0.8rem", marginRight: "8px" }}>
              (שגיאות: {getValidationErrors().join(", ")})
            </span>
          )}
        </h4>
        
        <div>
          <button
            type="button"
            className="btn"
            onClick={() => setExpanded(!expanded)}
            style={{
              padding: "4px 8px",
              fontSize: "0.8rem",
              marginLeft: "8px"
            }}
          >
            {expanded ? "▲ צמצם" : "▼ הרחב"}
          </button>
          
          <button
            type="button"
            onClick={onRemove}
            style={{
              background: "#e74c3c",
              color: "white",
              border: "none",
              padding: "4px 8px",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "0.8rem"
            }}
          >
            🗑️ מחק
          </button>
        </div>
      </div>

      {/* תצוגה מקוצרת */}
      {!expanded && (
        <div style={{ 
          padding: "8px",
          background: "var(--bg)",
          borderRadius: "4px",
          fontSize: "0.9rem"
        }}>
          <div style={{ marginBottom: "4px", fontWeight: "bold" }}>
            {value.question || "שאלה ללא טקסט"}
          </div>
          <div style={{ fontSize: "0.8rem", color: "var(--text)" }}>
            תשובה נכונה: {value.correctAnswer || "לא נבחרה"} | 
            נקודות: {value.points || 1}
          </div>
        </div>
      )}

      {/* תצוגה מורחבת */}
      {expanded && (
        <>
          {/* טקסט השאלה */}
          <div style={{ marginBottom: "16px" }}>
            <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>
              טקסט השאלה *
            </label>
            <textarea
              value={value.question}
              onChange={(e) => updateQuestion("question", e.target.value)}
              placeholder="הזן את השאלה כאן..."
              rows={3}
              style={{
                width: "100%",
                minHeight: "80px",
                resize: "vertical"
              }}
            />
          </div>

          {/* התשובות */}
          <div style={{ marginBottom: "16px" }}>
            <label style={{ display: "block", marginBottom: "12px", fontWeight: "bold" }}>
              תשובות אפשריות (בחר את הנכונה)
            </label>
            
            <div style={{ display: "grid", gap: "12px" }}>
              {value.options.map((option, optIndex) => (
                <div key={option.label} style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "12px",
                  borderRadius: "8px",
                  background: value.correctAnswer === option.label 
                    ? "rgba(39, 174, 96, 0.1)" 
                    : "var(--bg)",
                  border: value.correctAnswer === option.label 
                    ? "2px solid #27ae60" 
                    : "1px solid var(--text)"
                }}>
                  {/* כפתור בחירת תשובה נכונה */}
                  <button
                    type="button"
                    onClick={() => setCorrectAnswer(option.label)}
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      border: "2px solid",
                      borderColor: value.correctAnswer === option.label ? "#27ae60" : "var(--text)",
                      background: value.correctAnswer === option.label ? "#27ae60" : "transparent",
                      color: value.correctAnswer === option.label ? "white" : "var(--text)",
                      cursor: "pointer",
                      fontWeight: "bold",
                      fontSize: "1rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                    title={`בחר ${option.label} כתשובה נכונה`}
                  >
                    {value.correctAnswer === option.label ? "✓" : option.label}
                  </button>

                  {/* תווית התשובה */}
                  <div style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "4px",
                    background: "var(--accent)",
                    color: "#0b1c2b",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold"
                  }}>
                    {option.label}
                  </div>

                  {/* טקסט התשובה */}
                  <input
                    type="text"
                    value={option.text}
                    onChange={(e) => updateOption(optIndex, e.target.value)}
                    placeholder={`תשובה ${option.label}`}
                    style={{
                      flex: 1,
                      padding: "8px 12px",
                      border: option.text.trim() ? "1px solid var(--text)" : "1px solid #e74c3c",
                      borderRadius: "4px",
                      background: "var(--bg)",
                      color: "#ffffff"
                    }}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* הסבר ונקודות */}
          <div style={{ 
            display: "grid", 
            gridTemplateColumns: "2fr 1fr", 
            gap: "16px",
            marginBottom: "16px"
          }}>
            <div>
              <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>
                הסבר (אופציונלי)
              </label>
              <textarea
                value={value.explanation || ""}
                onChange={(e) => updateQuestion("explanation", e.target.value)}
                placeholder="הסבר למה התשובה הנכונה היא נכונה..."
                rows={2}
                style={{
                  width: "100%",
                  resize: "vertical"
                }}
              />
            </div>

            <div>
              <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>
                נקודות
              </label>
              <input
                type="number"
                min="1"
                max="10"
                value={value.points || 1}
                onChange={(e) => updateQuestion("points", +e.target.value)}
                style={{ width: "100%" }}
              />
            </div>
          </div>

          {/* תצוגת תקינות */}
          {!isValid() && (
            <div style={{
              background: "#fff3cd",
              border: "1px solid #ffeaa7",
              color: "#856404",
              padding: "12px",
              borderRadius: "8px",
              fontSize: "0.9rem"
            }}>
              <strong>שגיאות בשאלה:</strong>
              <ul style={{ margin: "8px 0 0 0", paddingRight: "20px" }}>
                {getValidationErrors().map((error, i) => (
                  <li key={i}>{error}</li>
                ))}
              </ul>
            </div>
          )}

          {/* תצוגה מקדימה */}
          {isValid() && (
            <div style={{
              background: "#e8f5e8",
              border: "1px solid #c1e1c1",
              padding: "16px",
              borderRadius: "8px",
              marginTop: "16px"
            }}>
              <h5 style={{ margin: "0 0 12px 0", color: "#2d5a2d" }}>
                תצוגה מקדימה:
              </h5>
              
              <div style={{ color: "#333", marginBottom: "12px", fontWeight: "bold" }}>
                {value.question}
              </div>
              
              <div style={{ display: "grid", gap: "8px" }}>
                {value.options.map((option) => (
                  <div key={option.label} style={{
                    padding: "8px 12px",
                    background: "white",
                    borderRadius: "4px",
                    border: value.correctAnswer === option.label 
                      ? "2px solid #27ae60" 
                      : "1px solid #ddd",
                    color: "#333"
                  }}>
                    <strong>{option.label}.</strong> {option.text}
                    {value.correctAnswer === option.label && (
                      <span style={{ color: "#27ae60", marginRight: "8px", fontWeight: "bold" }}>
                        ✓ תשובה נכונה
                      </span>
                    )}
                  </div>
                ))}
              </div>
              
              {value.explanation && (
                <div style={{ 
                  marginTop: "12px", 
                  padding: "8px 12px", 
                  background: "white", 
                  borderRadius: "4px",
                  color: "#333"
                }}>
                  <strong>הסבר:</strong> {value.explanation}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}